import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorI18nCacheService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-airport',
    templateUrl: './select-airport.component.html',
    styleUrls: ['./select-airport.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectAirportComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class SelectAirportComponent implements ControlValueAccessor {
    public options: { label: string; value: string }[] = [];
    @Input() placeholder = '';
    @Input() multiple = false;

    value: string | string[] | null = null;

    constructor(protected cacheI18n: ConfiguratorI18nCacheService) {
        this.cacheI18n.searchUsingGET('AIRPORT', true).subscribe(res => {
            this.options = res.filter(i => i.value && i.value.length > 0)
                .map( i => {
                    return {label: i.value, value: i.key || i.value };
                });
        });
    }

    onChange: (value: any) => void = () => {
    }
    onTouched: () => void = () => {
    }

    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setValue(value: string | string[]) {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
